import api from '@/services/api'

export const requestMigration = async (company) => {
  return await api.post(`/companies-service/migration/`, company, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}
